import httpClientWrapper from '@/helpers/HttpClientWrapper'
import jwtHelper from '@/helpers/JwtHelper'
import BookFilter from '@/model/BookFilter'
import utils from '@/helpers/Utils'
import { useAuthStore } from '@/stores/auth'
import userService from '@/service/UserService'

const userManagementService = {
    getCategories: getCategories,
    getOwners: getOwners,
    getMyAvailableBooks: getMyAvailableBooks,
    getAvailableBooks: getAvailableBooks,
    getAllBooks: getAllBooks,
    correctCovers: correctCovers,
    uploadBooks: uploadBooks,
    getPendingImportRequests: getPendingImportRequests,
    donwloadUploadRequest: donwloadUploadRequest,
    importBooks: importBooks,
    denyImportBooks: denyImportBooks,
    acceptImportBooks: acceptImportBooks,
}

async function getCategories() {
    return await httpClientWrapper.get('/api/books/categories', jwtHelper.makeHttpAuthorization())
}

async function getOwners() {
    const userResponse = await httpClientWrapper.get('/api/books/owners', jwtHelper.makeHttpAuthorization())
    const users = userResponse.result.collection
    userService.decorate(users)
    return users
}

async function getMyAvailableBooks(page, pageSize, filter) {
    const filterDto = (filter !== null && filter !== undefined) ? filter : new BookFilter()
    const authStore = useAuthStore()
    filterDto.ownerId = [authStore.user.id]
    const response = await httpClientWrapper.post(`/api/books/availableBook?page=${page}&pageSize=${pageSize}`, filterDto, jwtHelper.makeHttpAuthorization())
    decorate(response.result.collection)
    return response.result
}

async function getAvailableBooks(page, pageSize, filter) {
    const filterDto = (filter !== null && filter !== undefined) ? filter : new BookFilter()
    const response = await httpClientWrapper.post(`/api/books/availableBook?page=${page}&pageSize=${pageSize}`, filterDto, jwtHelper.makeHttpAuthorization())
    decorate(response.result.collection)
    return response.result
}

async function getAllBooks(page, pageSize, filter) {
    const filterDto = (filter !== null && filter !== undefined) ? filter : new BookFilter()
    const response = await httpClientWrapper.post(`/api/books/allBooks?page=${page}&pageSize=${pageSize}`, filterDto, jwtHelper.makeHttpAuthorization())
    decorate(response.result.collection)
    return response.result
}

async function correctCovers(booksIds) {
    return await httpClientWrapper.post('/api/books/correctCovers', booksIds, jwtHelper.makeHttpAuthorization())
}

async function uploadBooks(blob, name) {
    return await httpClientWrapper.postBlob('/api/books/uploadBooks', blob, name, jwtHelper.makeHttpAuthorization())
}

async function getPendingImportRequests() {
    return await httpClientWrapper.get('/api/books/pendingUploadRequests', jwtHelper.makeHttpAuthorization())
}

async function donwloadUploadRequest(requestId) {
    await httpClientWrapper.downloadFile(`/api/books/uploadRequests?requestId=${requestId}`, jwtHelper.makeHttpAuthorization())
}

async function importBooks(requestId, file, fileName) {
    return await httpClientWrapper.postBlob(`/api/books/importBooks/${requestId}`, file, fileName, jwtHelper.makeHttpAuthorization())
}

async function denyImportBooks(requestId) {
    return await httpClientWrapper.get(`/api/books/denyBooksImport?requestId=${requestId}`, jwtHelper.makeHttpAuthorization())
}

async function acceptImportBooks(requestId) {
    return await httpClientWrapper.get(`/api/books/acceptBooksImport?requestId=${requestId}`, jwtHelper.makeHttpAuthorization())
}

function decorate(books) {
    books.forEach(b => b['selected'] = false)
    books.forEach(b => b['abvTitle'] = utils.truncateText(b['title'], 20))
    books.forEach(b => b['abvAuthor'] = utils.truncateText(b['author'], 20))
    for (const book of books) {
        if (book.imageUrl === null || book.imageUrl === undefined) {
            book.imageUrl = require('@/assets/blank_book_cover.jpg')
        }
    }
}

export default userManagementService